import { cn } from "@gymflow/helpers";

export function HostedPagesFooter({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "dark:bg-gray-950 w-full dark:border-gray-700 dark:text-gray-400 flex h-9 items-center justify-center border-t border-gray-300 px-4 text-sm text-gray-500 bg-gray-0 font-medium",
        className,
      )}
    >
      Powered by&nbsp;
      <a
        className="text-primary-600 hover:!text-primary-600 font-semibold underline"
        href="https://gymflow.io"
        target="_blank"
        rel="noreferrer"
      >
        Gymflow.io
      </a>
    </div>
  );
}
